module.exports = __webpack_public_path__ + "static/media/thinking-in-bets.dd8e0d6a.jpeg";